"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDomainForURLs = getDomainForURLs;
exports.getCurrentLocale = getCurrentLocale;
exports.setLocaleCookie = setLocaleCookie;
exports.initCookiePolicyPopup = initCookiePolicyPopup;
exports.initExpandingFooterColumns = initExpandingFooterColumns;
exports.registerHamburgerEvents = registerHamburgerEvents;

var _constants = require("./constants.js");

var _utilFunctions = require("./utilFunctions");

// Contains logic shared between React component and compiled Static Markup.
function getDomainForURLs(domainSetting) {
  // Localhost or empty setting does not make sense for constructing composite URLs
  if (!domainSetting || domainSetting.indexOf('localhost') !== -1) {
    return _constants.DEFAULT_DOMAIN;
  }

  return domainSetting;
}

function getCurrentLocale() {
  var rawLocaleLower = getRawLocaleValue().toLowerCase();
  var normalizedLocale = _constants.LOCALES_LOWER_TO_NORMAL[rawLocaleLower];

  if (normalizedLocale) {
    return normalizedLocale;
  }

  var rawLangLower = rawLocaleLower.slice(0, 2);
  var mappedFromLanguageOnly = _constants.LOCALES_LANGUAGE_ONLY_TO_NORMAL[rawLangLower];

  if (mappedFromLanguageOnly) {
    return mappedFromLanguageOnly;
  }

  return _constants.DEFAULT_LOCALE;
}

function getRawLocaleValue() {
  var cookieLocale = (0, _utilFunctions.__getCookie)(_constants.COOKIE_KEY_LOCALE);

  if (cookieLocale) {
    return cookieLocale;
  }

  var allLocaleKeys = Object.keys(_constants.ALL_LOCALES);

  for (var i = 0, length = allLocaleKeys.length; i < length; i++) {
    var candidateLocale = allLocaleKeys[i];
    var urlMatcher = new RegExp("\\/".concat(candidateLocale, "(?:\\/|$)"), 'i');

    if (urlMatcher.test(window.location)) {
      return candidateLocale;
    }
  }

  return navigator.language;
}

function setLocaleCookie(newLocale, domain) {
  (0, _utilFunctions.setCookie)(_constants.COOKIE_KEY_LOCALE, newLocale.toLowerCase(), domain);
}

function initCookiePolicyPopup(popupContainerElement, cookieDomain, enableAnalytics) {
  var showTimeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 750;

  /* eslint no-param-reassign: ["error", { "props": false }] */
  return new Promise(function (resolve) {
    if (!popupContainerElement || popupContainerElement.className === 'shown') {
      resolve();
      return;
    }

    var cookiesAccepted = (0, _utilFunctions.__getCookie)(_constants.COOKIE_KEY_COOKIES_ACCEPTED);

    if (cookiesAccepted === 'true') {
      resolve();
      return;
    }

    var showPopupFunction = function showPopupFunction() {
      var SHOWN_CLASS = 'shown'; // Hook close button

      popupContainerElement.querySelector('#cookiePopupCloseButton').addEventListener('click', function () {
        popupContainerElement.classList.remove(SHOWN_CLASS);
      });
      popupContainerElement.querySelector('#cookiePopupAcceptEU').addEventListener('click', function () {
        (0, _utilFunctions.setCookie)(_constants.COOKIE_KEY_COOKIES_ACCEPTED, true, cookieDomain);
        (0, _utilFunctions.setCookie)('Preferences', true, cookieDomain);
        (0, _utilFunctions.setCookie)('Performance', true, cookieDomain);
        (0, _utilFunctions.setCookie)('Marketing', true, cookieDomain);
        popupContainerElement.classList.remove(SHOWN_CLASS);
        enableAnalytics();
      });
      popupContainerElement.querySelector('#cookiePopupSettings').addEventListener('click', function () {
        popupContainerElement.classList.remove(SHOWN_CLASS);
      }); // Show the popup

      popupContainerElement.classList.add(SHOWN_CLASS);
      resolve();
    };

    try {
      fetch('https://www.snapchat.com/cookies/api/is_cookie_popup_eligible').then(function (res) {
        if (res.status !== 200) {
          var status = res.status,
              statusText = res.statusText;
          throw new Error("".concat(status, " : ").concat(statusText));
        }

        return res.json();
      }).then(function (_ref) {
        var popupEnabled = _ref.popupEnabled;

        if (!popupEnabled || (0, _utilFunctions.__getCookie)(_constants.COOKIE_KEY_COOKIES_ACCEPTED) === 'true') {
          (0, _utilFunctions.setCookie)(_constants.COOKIE_KEY_COOKIES_ACCEPTED, true, cookieDomain);
          (0, _utilFunctions.setCookie)('Preferences', true, cookieDomain);
          (0, _utilFunctions.setCookie)('Performance', true, cookieDomain);
          (0, _utilFunctions.setCookie)('Marketing', true, cookieDomain);
          enableAnalytics();
          resolve();
        } else {
          setTimeout(function () {
            return showPopupFunction();
          }, showTimeout);
          resolve();
        }
      });
    } catch (error) {
      // Failure of security or network connection promps the popup to show
      setTimeout(showPopupFunction, showTimeout);
      resolve();
    }
  });
}

function toggleExpandFooterColumn(mouseEvent) {
  var element = mouseEvent.target; // Ensure we are triggering the .footer-column element regardless of click target

  while (element && !(element.classList && element.classList.contains('footer-column'))) {
    if (element.tagName === 'A') {
      // Ignore click on the links
      return;
    }

    element = element.parentNode;
  }

  if (!element) {
    return;
  }

  element.classList.toggle('expanded');
}

function initExpandingFooterColumns(footerContainerElement) {
  if (!footerContainerElement) {
    return;
  }

  footerContainerElement.addEventListener('click', toggleExpandFooterColumn);
}

function registerHamburgerEvents(hamburgerElement) {
  if (!hamburgerElement) {
    return;
  }

  hamburgerElement.addEventListener('click', function (clickEvent) {
    var element = clickEvent.target;

    while (element && !(element.classList && element.classList.contains('header-container'))) {
      element = element.parentNode;
    }

    if (!element) {
      return;
    }

    element.classList.toggle('hamburger-expanded');
  });
}